import { postAction ,getAction } from '@api/manage'
import bus from '@/utils/vueBus'
export default {
  install (Vue, options) {
    Vue.prototype.ExportSavePdf = async function (object) {
      var html = "<html lang=\"zh-cmn-Hans\" class=\" \">";
      var headHtml = document.getElementsByTagName("head")[0];
      let elementsByTagName = document.getElementsByTagName("input");
      for (let i = 0; i < elementsByTagName.length; i++) {
        elementsByTagName[i].setAttribute("value", elementsByTagName[i].value);
      }
      //input框内容过长转为span标签
      if(object.isInputExpand && object.isInputExpand == "1"){
        for (let i = 0; i < elementsByTagName.length; i++) {
          if(elementsByTagName[i].type=="text"||elementsByTagName[i].type==""){
            var s = document.createElement('span')
            s.setAttribute("name","spanName")
            s.innerText=elementsByTagName[i].value
            s.style = "text-decoration: underline;"
            var parent =elementsByTagName[i].parentNode;
            parent.insertBefore(s,elementsByTagName[i]);
            elementsByTagName[i].style.display="none";
          }
        }
      }

      let array = new Array();
      let array1 = new Array();
      let elementsByClassName = document.getElementsByClassName("tinymce-editor");
      let elementNodeListOf = document.querySelectorAll(".tinymce-editor>textarea");
      for (let i = 0; i < elementsByClassName.length; i++) {
        let attributeId = elementNodeListOf[i].getAttribute("id");
        // 下面这个IE兼容性问题更改写法
        //elementsByClassName[i].innerHTML = window.frames[attributeId + '_ifr'].contentWindow.document.body.innerHTML;
        array.push(elementsByClassName[i].innerHTML);
        array1.push(document.getElementById(attributeId + '_ifr').contentWindow.document.getElementsByTagName('html')[0].innerHTML);
        // elementsByClassName[i].innerHTML = document.getElementById(attributeId + '_ifr').contentWindow.document.body.innerHTML;
        elementsByClassName[i].insertAdjacentHTML("afterend", '<div id="div_' + attributeId + '">' + document.getElementById(attributeId + '_ifr').contentWindow.document.getElementsByTagName("html")[0].innerHTML + '</div>');
        elementsByClassName[i].style.display = 'none';
      }

      let textareaNodes = document.getElementsByTagName("textarea");
      for (let i = 0; i < textareaNodes.length; i++) {
        let textareaId = textareaNodes[i].getAttribute("id");
        if(textareaId != null && textareaId.indexOf("tiny-vue") > -1) {
          continue
        }
        var brReg =new RegExp("\n","igm");
        textareaNodes[i].insertAdjacentHTML("afterend", '<div id="textarea_' + textareaId + '">' + textareaNodes[i].value.replace(brReg,"<br>") + '</div>');
        textareaNodes[i].style.display = 'none';
      }


      let frToolbars = document.getElementsByClassName("fr-toolbar")
      for (let i = 0; i < frToolbars.length; i++) {
        frToolbars[i].style.display = 'none';
      }

      var pdfCententHtml = "";
      if(object.isEditorCuring && object.isEditorCuring == "1"){
        pdfCententHtml = document.getElementById("editorCentent");
        if(!pdfCententHtml){
          pdfCententHtml = document.getElementById("pdfCentent");
        }
      }else{
        pdfCententHtml = document.getElementById("pdfCentent");
      }

      // 修复富文本编辑器转换pdf边框问题
      document.head.innerHTML += "<style> body { margin: 0px !important } </style>";

      pdfCententHtml.style.padding = "10px";

      //实现转为pdf格式后水印的全覆盖
      var pdfmark = document.getElementById("pdfmark");
      if (pdfmark !== null) {
        var height = document.body.scrollHeight+document.body.offsetHeight;
        pdfmark.style.height= height+'px';
      }

      html += headHtml.innerHTML;
      /*html += "<style>";
      html += stampcss;
      html += "</style>";*/
      html += pdfCententHtml.innerHTML;
      html += "</html>";
      var r=new RegExp("<script.*src.*></script>","igm");
      var r1=new RegExp("<link href=.*rel=\"prefetch\">","igm");
      var r2=new RegExp("<link href=.*rel=\"preload\" as=\"script\">","igm");
      var r3=new RegExp("<link rel=\"icon\" href=.*\">","igm");
      var r4=new RegExp("@media [(]min-width: 576px[)] \{","igm");
      // html = html.replace(r," ");
      html = html.replace(/<link href="\/css\/chunk/g,"<link href=\""+window._CONFIG['frameDomainURL']+"css/chunk")
      html = html.replace(/href="\//g,"href=\""+window._CONFIG['frameDomainURL']+"/")
      // html = html.replace(/display: flex;/g,"display: flex;display: -webkit-box;")
      // html = html.replace(r1," ");
      // html = html.replace(r2," ");
      // html = html.replace(r3," ");
      html = html.replace(r4,"@media all {");
      let params = object;
      params.pdfHtml = html;

      for (let i = 0; i < elementsByClassName.length; i++) {
        let attributeId = elementNodeListOf[i].getAttribute("id");
        var idDiv = document.getElementById("div_" + attributeId);
        idDiv.remove();
        elementsByClassName[i].style.display = 'block';
        // elementsByClassName[i].innerHTML = array[i];
        // document.getElementById(attributeId + '_ifr').contentWindow.document.getElementsByTagName('html')[0].innerHTML = array1[i];
      }

      for (let i = 0; i < textareaNodes.length; i++) {
        let textareaId = textareaNodes[i].getAttribute("id");
        if(textareaId != null && textareaId.indexOf("tiny-vue") > -1) {
          continue
        }
        var idDiv = document.getElementById("textarea_" + textareaId);
        idDiv.remove();
        textareaNodes[i].style.display = 'block';
      }

      for (let i = 0; i < frToolbars.length; i++) {
        frToolbars[i].style.display = '';
      }

      //还原转为span标签的input框
      if(object.isInputExpand && object.isInputExpand == "1"){
        let elementsByTagNamespan = document.getElementsByName("spanName");
        for (let i = 0; i < elementsByTagNamespan.length; i++) {
          elementsByTagNamespan[i].style.display="none";
        }
        for (let i = 0; i < elementsByTagName.length; i++) {
          if (elementsByTagName[i].type == "text" || elementsByTagName[i].type == "") {
            elementsByTagName[i].style.display = "";
          }
        }
      }

      let pdfUrl = "";
      await postAction("/ebid-ce/stamp/putStampContent", params).then((res) => {
        if (res.success) {
          params.pdfUrl = res.result;
        } else {
        }
      })
      return params;
    }
    Vue.prototype.ExportHtml = async function (object) {
        var html = "<html lang=\"zh-cmn-Hans\" class=\" \">";
        var headHtml = document.getElementsByTagName("head")[0];
        let elementsByTagName = document.getElementsByTagName("input");
        for (let i = 0; i < elementsByTagName.length; i++) {
          elementsByTagName[i].setAttribute("value", elementsByTagName[i].value);
        }

        let array = new Array();
        let array1 = new Array();
        let elementsByClassName = document.getElementsByClassName("tinymce-editor");
        let elementNodeListOf = document.querySelectorAll(".tinymce-editor>textarea");
        for (let i = 0; i < elementsByClassName.length; i++) {
          let attributeId = elementNodeListOf[i].getAttribute("id");
          // 下面这个IE兼容性问题更改写法
          //elementsByClassName[i].innerHTML = window.frames[attributeId + '_ifr'].contentWindow.document.body.innerHTML;
          array.push(elementsByClassName[i].innerHTML);
          array1.push(document.getElementById(attributeId + '_ifr').contentWindow.document.getElementsByTagName('html')[0].innerHTML);
          elementsByClassName[i].innerHTML = document.getElementById(attributeId + '_ifr').contentWindow.document.getElementsByTagName('html')[0].innerHTML;
        }

        let frToolbars = document.getElementsByClassName("fr-toolbar")
        for (let i = 0; i < frToolbars.length; i++) {
          frToolbars[i].style.display = 'none';
        }

        var pdfCententHtml = "";
        if(object.isEditorCuring && object.isEditorCuring == "1"){
          pdfCententHtml = document.getElementById("editorCentent");
          if(!pdfCententHtml){
            pdfCententHtml = document.getElementById("pdfCentent");
          }
        }else{
          pdfCententHtml = document.getElementById("pdfCentent");
        }


        html += headHtml.innerHTML;
        /*html += "<style>";
        html += stampcss;
        html += "</style>";*/
        html += pdfCententHtml.innerHTML;
        html += "</html>";
        var r=new RegExp("<script.*src.*></script>","igm");
        var r1=new RegExp("<link href=.*rel=\"prefetch\">","igm");
        var r2=new RegExp("<link href=.*rel=\"preload\" as=\"script\">","igm");
        var r3=new RegExp("<link rel=\"icon\" href=.*\">","igm");
        var r4=new RegExp("@media [(]min-width: 576px[)] \{","igm");
        // html = html.replace(r," ");
        html = html.replace(/<link href="\/css\/chunk/g,"<link href=\""+window._CONFIG['frameDomainURL']+"css/chunk")
        html = html.replace(/href="\//g,"href=\""+window._CONFIG['frameDomainURL']+"/")
        // html = html.replace(r1," ");
        // html = html.replace(r2," ");
        // html = html.replace(r3," ");
        html = html.replace(r4,"@media all {");
        let params = object;
        params.html = html;

        for (let i = 0; i < elementsByClassName.length; i++) {
          let attributeId = elementNodeListOf[i].getAttribute("id");
          elementsByClassName[i].innerHTML = array[i];
          document.getElementById(attributeId + '_ifr').contentWindow.document.getElementsByTagName('html')[0].innerHTML = array1[i];
        }

        for (let i = 0; i < frToolbars.length; i++) {
          frToolbars[i].style.display = '';
        }

        await postAction("/ebid-ce/file/saveHtmlFile", params).then((res) => {
          if (res.success) {
            params.res = true;
          } else {
            params.res = false;
          }
        }).catch(function() {
          params.res = false;
        })
        return params;
      }
  }
}